import {NinchatProperties} from '../../api/types'
import React from 'react'
import SidebarQueue from './SidebarQueue/SidebarQueue'
import {SidebarQueuesViewProps} from './types'
import {styled} from 'stitches/config'
import {styledGroup} from 'components/Sidebar/styles'
import {useTranslation} from 'react-i18next'

const StyledGroup = styled('ul', styledGroup)

const SidebarQueuesView = (props: SidebarQueuesViewProps): React.ReactElement => {
    const {
        loadQueue,
        loadQueueSettings,
        loadQueueStatistics,
        nestedSidebar,
        onAcceptAudience,
        onToggleQueue,
        queues,
    } = props

    const {t} = useTranslation()

    return (
        <StyledGroup aria-label={t('Queues')}>
            {
                queues.map((queue_id: NinchatProperties.QueueID) => (
                    <SidebarQueue
                        key={queue_id}
                        loadQueue={loadQueue}
                        loadQueueSettings={loadQueueSettings}
                        loadQueueStatistics={loadQueueStatistics}
                        nestedSidebar={nestedSidebar}
                        onAcceptAudience={onAcceptAudience}
                        onToggleQueue={onToggleQueue}
                        queue_id={queue_id}
                    />))
            }
        </StyledGroup>
    )
}

export default SidebarQueuesView
